<template>
    <div class="new-chat-list">
        <template v-if="list.length">
            <new-chat-contact-item
                v-for="item in list"
                :key="item.id"
                :item="item"
                @click="$emit('select', $event)"
            />
        </template>
        <div v-else class="new-chat-list__empty">Нет чатов</div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import NewChatContactItem from './NewChatContactItem.vue'

export default {
    name: 'NewChatCommonList',
    components: { NewChatContactItem },
    computed: {
        ...mapGetters('newChat', ['list'])
    }
}
</script>
